import axios from 'axios'
import { showToast } from 'vant'

// 根据环境设置 baseURL
const isDevelopment = process.env.NODE_ENV === 'development'
const baseURL = isDevelopment ? 'https://gdmapi.gogo365.com' : 'https://gdmapi.gogo365.com'

// 创建 axios 实例
const service = axios.create({
  baseURL,
  timeout: 15000
})

// 获取存储的 token
const getToken = () => {
  return localStorage.getItem('token')
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    console.log('发送请求:', config.url, config)
    
    // 添加 token 到请求头
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}` // 添加 Bearer 前缀
    }
    
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    console.log('接收响应:', response.config.url, res)
    
    // 如果响应是字符串，尝试解析 JSON
    if (typeof res === 'string') {
      try {
        const parsedData = JSON.parse(res)
        console.log('解析后的数据:', parsedData)
        return parsedData
      } catch (e) {
        console.error('解析响应数据失败:', e)
        return { data: [], message: '解析响应数据失败' }
      }
    }

    // 处理 token 失效的情况
    if (res.ErrorCode === 401 || res.ErrorCode === 403) {
      showToast('登录已过期，请重新登录')
      // 清除本地存储的 token
      localStorage.removeItem('token')
      // 如果不是登录相关的接口，才跳转到登录页
      if (!response.config.url.includes('/Login/')) {
        window.location.href = '/'
      }
      return Promise.reject(new Error('未登录或登录已过期'))
    }

    return res || []
  },
  error => {
    console.error('响应错误:', error)
    // 如果是网络错误或服务器错误，不要跳转页面
    const errorMessage = error.response?.data?.message || error.message || '请求失败'
    showToast(errorMessage)
    return Promise.reject(error)
  }
)

export default service
